export default __webpack_public_path__ + "static/media/2224.49e5028e.png";